import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { CalendarDaysIcon } from "@heroicons/react/20/solid";
import Loader from '../../../utils/Loader';

const PlanCreate = ({ close }) => {
  const [formData, setFormData] = useState({
    name: "",
    amount: "",
    no_of_months: "",
  });

  const [planAmounts, setPlanAmounts] = useState([]);
  const [validation, setValidation] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "no_of_months") {
      const months = parseInt(value);
      if (!isNaN(months) && months > 0) {
        const updated = Array.from({ length: months }, (_, i) => ({
          month: `Month ${i + 1}`,
          amount: "",
          reduction_amount: "",
          payable_amount: ""
        }));
        setPlanAmounts(updated);
      } else {
        setPlanAmounts([]);
      }
    }
  };

  const handleAmountChange = (index, field, value) => {
    const updated = [...planAmounts];
    updated[index][field] = value;
    setPlanAmounts(updated);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true)


    setIsSubmitting(true);

    try {
      const token = localStorage.getItem("token");

      const dataToSend = {
        ...formData,
        plan_amounts: planAmounts,
      };

      const response = await axios.post("public/api/plans", dataToSend, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success(response.data.message);
      close(); // Close the modal/component
    } catch (error) {
      if (error.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm");
      }
      // setError(error.response.data.messaage || " Please check your internet connection and try again." )
      setValidation(error.response?.data || {});
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Loader />
    )
  }

  if (error) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
        <div className="bg-white rounded-lg shadow-lg p-8 max-w-md">
          <div className="flex items-center justify-center mb-6">
            <svg
              className="h-12 w-12 text-red-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>

          <p className="text-gray-600 mb-8 text-center">
            Please check your internet connection and try again.
          </p>
          <div className="flex justify-center">
            <button
              className="bg-[#0f172a] hover:bg-teal-900 text-white font-semibold py-2 px-4 rounded transition duration-300"
              onClick={fetch}
            >
              Try Again
            </button>
          </div>
        </div>
      </div>
    )

  }

  return (
    <div className="p-6">
      <div className="flex items-center justify-end  w-full">
        <button
          onClick={close}
          className="text-gray-500 hover:text-gray-700 focus:outline-none"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="black"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        </button>
      </div>

      <div className='flex flex-col items-center mt-6  '>


        <div className="bg-blue-500 text-white p-3  rounded-full">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="40" height="40" color="#000000" fill="none">
            <path d="M18.5 20V17.9704C18.5 16.7281 17.9407 15.5099 16.8103 14.9946C15.4315 14.3661 13.7779 14 12 14C10.2221 14 8.5685 14.3661 7.18968 14.9946C6.05927 15.5099 5.5 16.7281 5.5 17.9704V20" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <circle cx="12" cy="7.5" r="3.5" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></circle>
          </svg>
        </div>
        <h1 className='text-3xl font-bold mt-4'>Add New Plan</h1>

        <p className="text-gray-600 mt-2 text-center">
          Complete the form below to add a new Customer to your chit fund.
          All fields marked with <span className="text-red-500">*</span> are required.
        </p>
      </div>
      <div className=' border-b-2 mt-4 '></div>
      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Plan Name */}
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-gray-700 flex items-center gap-2">
              <span className='border bg-blue-100 rounded-full p-1'>

                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#bd10e0" fill="none">
                  <path d="M18.5 20V17.9704C18.5 16.7281 17.9407 15.5099 16.8103 14.9946C15.4315 14.3661 13.7779 14 12 14C10.2221 14 8.5685 14.3661 7.18968 14.9946C6.05927 15.5099 5.5 16.7281 5.5 17.9704V20" stroke="#bd10e0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                  <circle cx="12" cy="7.5" r="3.5" stroke="#bd10e0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></circle>
                </svg>
              </span>Plan Name  <span className='text-lg'> *</span>
            </label>

            <input
              id="name"
              name="name"
              type="text"
              placeholder="Enter name"
              value={formData.name}
              onChange={handleChange}
              className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
            <p className="text-red-600 text-sm mt-1">{validation.errors?.name}</p>
          </div>

          {/* Plan Amount */}
          <div>
            <label htmlFor="phone"
              className="block text-sm font-medium text-gray-700 flex items-center gap-2"
            >

              <span className='border bg-red-100 rounded-full p-1 '>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#d0021b" fill="none">
                  <path d="M2.01733 15C4.2169 15 6.00001 16.7831 6.00001 18.9827" stroke="#d0021b" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M18 18.9827V18.8908C18 16.742 19.742 15 21.8908 15" stroke="#d0021b" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M6.00001 5.01733C6.00001 7.2169 4.2169 9.00001 2.01733 9.00001" stroke="#d0021b" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M18 5.01733C18 7.19765 19.769 8.96876 21.9423 8.9996" stroke="#d0021b" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M16 5H8C5.17157 5 3.75736 5 2.87868 5.87868C2 6.75736 2 8.17157 2 11V13C2 15.8284 2 17.2426 2.87868 18.1213C3.75736 19 5.17157 19 8 19H16C18.8284 19 20.2426 19 21.1213 18.1213C22 17.2426 22 15.8284 22 13V11C22 8.17157 22 6.75736 21.1213 5.87868C20.2426 5 18.8284 5 16 5Z" stroke="#d0021b" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z" stroke="#d0021b" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </span>
             Plan Amount
              <span className='text-lg'> *</span>
            </label>
            <input
              id="amount"
              name="amount"
              type="number"
              placeholder="Enter amount"
              value={formData.amount}
              onChange={handleChange}
              className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
            <p className="text-red-600 text-sm mt-1">{validation.errors?.amount}</p>
          </div>

          {/* No of Months */}
          <div>
            <label htmlFor="phone"
              className="block text-sm font-medium text-gray-700 flex items-center gap-2"
            >

              <span className='border bg-red-100 rounded-full p-1 '>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#000000" fill="none">
                  <path d="M13.55 1.75H9.93998C8.10998 1.75 6.64999 1.75015 5.50999 1.90015C4.33999 2.06015 3.38999 2.39014 2.63999 3.14014C1.89 3.89014 1.56001 4.84001 1.40001 6.01001C1.31001 6.68001 1.27999 7.47012 1.25999 8.37012C1.24999 8.42012 1.24998 8.46 1.24998 8.5C1.24998 8.54 1.24999 8.5701 1.25999 8.6001C1.24999 9.1701 1.24998 9.77994 1.24998 10.4399V11.5601C1.24998 13.3901 1.25001 14.85 1.40001 15.99C1.56001 17.16 1.89 18.1101 2.63999 18.8601C3.38999 19.6101 4.33999 19.9401 5.50999 20.1001C6.64999 20.2501 8.10998 20.25 9.93998 20.25H9.99998C10.41 20.25 10.75 19.91 10.75 19.5C10.75 19.09 10.41 18.75 9.99998 18.75C8.08998 18.75 6.74 18.7501 5.71 18.6101C4.7 18.4701 4.12999 18.22 3.69999 17.8C3.27999 17.37 3.02999 16.8 2.88999 15.79C2.74999 14.76 2.74998 13.41 2.74998 11.5V9.25H20.25V10C20.25 10.41 20.59 10.75 21 10.75C21.41 10.75 21.75 10.41 21.75 10V9.94995V8.40991C21.74 7.50991 21.71 6.73008 21.63 6.08008C21.51 5.04008 21.25 4.19999 20.67 3.48999C20.47 3.24999 20.25 3.03008 20.01 2.83008C19.3 2.25008 18.46 1.99012 17.42 1.87012C16.42 1.75012 15.15 1.75 13.55 1.75ZM20.23 7.75H2.78001C2.80001 7.16 2.82999 6.65996 2.88999 6.20996C3.02999 5.19996 3.27999 4.62995 3.69999 4.19995C4.12999 3.77995 4.7 3.53014 5.71 3.39014C6.74 3.25014 8.08998 3.25 9.99998 3.25H13.5C15.16 3.25 16.34 3.25011 17.25 3.36011C18.14 3.46011 18.66 3.65999 19.06 3.98999C19.23 4.11999 19.38 4.26994 19.51 4.43994C19.84 4.83994 20.04 5.36 20.14 6.25C20.19 6.68 20.22 7.17 20.23 7.75ZM4.49998 5.5C4.49998 4.95 4.94998 4.5 5.49998 4.5H5.50999C6.05999 4.5 6.50999 4.95 6.50999 5.5C6.50999 6.05 6.05999 6.5 5.50999 6.5H5.49998C4.94998 6.5 4.49998 6.05 4.49998 5.5ZM8.48997 5.5C8.48997 4.95 8.93997 4.5 9.48997 4.5H9.49998C10.05 4.5 10.5 4.95 10.5 5.5C10.5 6.05 10.05 6.5 9.49998 6.5H9.48997C8.93997 6.5 8.48997 6.05 8.48997 5.5ZM21.71 12.4099C20.83 11.5299 19.41 11.5299 18.53 12.4099L13.06 17.8801C12.54 18.4001 12.25 19.1001 12.25 19.8301V21.5C12.25 21.91 12.59 22.25 13 22.25H14.67C15.4 22.25 16.1 21.9599 16.62 21.4399L22.09 15.97C22.97 15.09 22.97 13.67 22.09 12.79L21.71 12.4099ZM19.59 13.47C19.88 13.18 20.36 13.18 20.65 13.47L21.03 13.8501C21.32 14.1401 21.32 14.6199 21.03 14.9099L15.56 20.3801C15.32 20.6201 15 20.75 14.67 20.75H13.75V19.8301C13.75 19.5001 13.88 19.1799 14.12 18.9399L19.59 13.47Z" fill="#141B34" />
                </svg>
              </span>
              No of Month
              <span className='text-lg'> *</span>
            </label>
            <input
              name="no_of_months"
              type="number"
              value={formData.no_of_months}
              onChange={handleChange}
              className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              placeholder="Enter number of months"
            />
            <p className="text-red-600 text-sm">{validation.errors?.no_of_months}</p>
          </div>
        </div>

        {/* Monthly Plan Amounts */}
        <div className="mt-6">
          {planAmounts.length > 0 && ( <h2 className="text-md font-semibold mb-2">Monthly Amounts</h2>)}
         
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {planAmounts.map((item, index) => (
              <div key={index} className="bg-gray-50 p-4 rounded shadow">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  {item.month} <span className="text-red-500">*</span>
                </label>

                {/* Reduction Amount */}
                <input
                  type="number"
                  value={item.reduction_amount}
                  onChange={(e) => handleAmountChange(index, "reduction_amount", e.target.value)}
                  className={`mt-1 block w-full rounded-md shadow-sm sm:text-sm mb-1 ${validation.errors?.[`plan_amounts.${index}.reduction_amount`] ? "border-red-500 border" : "border-gray-300"
                    }`}
                  placeholder={`Reduction Amount for ${item.month}`}
                />
                {validation.errors?.[`plan_amounts.${index}.reduction_amount`] && (
                  <p className="text-sm text-red-600">
                    {validation.errors[`plan_amounts.${index}.reduction_amount`][0]}
                  </p>
                )}

                {/* Payable Amount */}
                <input
                  type="number"
                  value={item.payable_amount}
                  onChange={(e) => handleAmountChange(index, "payable_amount", e.target.value)}
                  className={`mt-1 block w-full rounded-md shadow-sm sm:text-sm mb-1 ${validation.errors?.[`plan_amounts.${index}.payable_amount`] ? "border-red-500 border" : "border-gray-300"
                    }`}
                  placeholder={`Payable Amount for ${item.month}`}
                />
                {validation.errors?.[`plan_amounts.${index}.payable_amount`] && (
                  <p className="text-sm text-red-600">
                    {validation.errors[`plan_amounts.${index}.payable_amount`][0]}
                  </p>
                )}

                {/* Total Amount */}
                <input
                  type="number"
                  value={item.amount}
                  onChange={(e) => handleAmountChange(index, "amount", e.target.value)}
                  className={`mt-1 block w-full rounded-md shadow-sm sm:text-sm ${validation.errors?.[`plan_amounts.${index}.amount`] ? "border-red-500 border" : "border-gray-300"
                    }`}
                  placeholder={`Amount for ${item.month}`}
                />
                {validation.errors?.[`plan_amounts.${index}.amount`] && (
                  <p className="text-sm text-red-600">
                    {validation.errors[`plan_amounts.${index}.amount`][0]}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Submit */}
        <div className="mt-6 text-right">
          <button
            type="submit"

            className="px-6 py-2 bg-[#0f172a] text-white rounded hover:bg-teal-900 disabled:opacity-50"
          >
            {"Save"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default PlanCreate;
